module.exports = __webpack_public_path__ + "img/sx-3.35774911.png";